/**
 * Created by Carsten Bühler
 * User: CBuehler on 27.01.2016
 * Copyright: xdot GmbH 2015
 */
let cache = {};

requestCache();

function requestCache() {
    let xhttp = new XMLHttpRequest();
    let value = undefined;
    let url = location.origin + '/delegate/languageCache/' + Liferay.ThemeDisplay.getLanguageId();

    xhttp.onreadystatechange = function () {
        if (xhttp.readyState === 4 && xhttp.status === 200) {
            if (xhttp.responseText && xhttp.responseText.length > 0) {
                cache = JSON.parse(xhttp.responseText);
            }
        }
    };

    xhttp.open('GET', url, false);
    xhttp.setRequestHeader('X-CSRF-Token', Liferay.authToken);
    xhttp.send();

    return value;
}

function applyExtraParams(translation, extraParams) {
    let i = 0;
    if (extraParams && Array.isArray(extraParams) && extraParams.length > 0) {
        extraParams.forEach(param => {
            let r = '{' + i + '}';
            if (translation.indexOf(r) < 0) {
                console.warn('No matching extraParam ' + i + ' found for translation: ', translation, extraParams);
            }
            translation = translation.replace(r, param);
            i++;
        });
    }
    return translation;
}

const requestTranslation = (key) => {
    const url = location.origin + '/delegate/language/' + Liferay.ThemeDisplay.getLanguageId() + '/' + key + '/';
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (xhttp.readyState === 4 && xhttp.status === 200) {
            const txt = xhttp.responseText;
            cache[ key ] = txt.length === 0 || txt === key ? noTranslation(key) : txt;
        }
    };
    xhttp.open('GET', url);
    xhttp.setRequestHeader('X-CSRF-Token', Liferay.authToken);
    xhttp.send();
    return xhttp;
};

const getTranslation = (key, extraParams) => {
    let v = cache[ key ];
    if (!v) {
        console.warn('Missing translation "' + key + "'");
        requestTranslation(key);
        cache[ key ] = v = noTranslation(key);
    }
    return applyExtraParams(v, extraParams);
};

const noTranslation = key => '###.' + key + '.###';

export default {
    trans(key) {
        let extraParams = arguments.length >= 2 ? Array.prototype.slice.call(arguments, 1) : undefined;
        return getTranslation(key, extraParams);
    },
    transException(key) {
        if (key) {
            let extraParams = arguments.length >= 2 ? Array.prototype.slice.call(arguments, 1) : undefined;
            const parts = key.split('.');
            return getTranslation(parts[ parts.length > 0 ? parts.length - 1 : 0 ], extraParams);
        }
        return '';
    }
};




// WEBPACK FOOTER //
// ./js/utils/translation.js